module.exports = __webpack_public_path__ + "static/media/logo-big.18e5cc17.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/images/logo-big.jpg
 ** module id = 859
 ** module chunks = 0
 **/